import { useState } from 'react';
import { SearchTermList, useSearchTermCompleteToast } from '../../../hooks/useSearchTerms';
import { ListsView } from './ListsView';
import { ListDetail } from './ListDetail';

export function SearchTermsTab({ projectId }: { projectId: string }) {
  const [selectedList, setSelectedList] = useState<SearchTermList | null>(null);
  useSearchTermCompleteToast(projectId, selectedList?.id);

  return (
    <div>
      <h2>
        <i className="fas fa-search" aria-hidden="true" /> Search Terms
        {selectedList && <small> {selectedList.name}</small>}
      </h2>
      {!selectedList
        ? <ListsView projectId={projectId} onOpen={setSelectedList} />
        : <ListDetail projectId={projectId} list={selectedList} onBack={() => setSelectedList(null)} />}
    </div>
  );
}
